<template>
	<v-app>
		<v-main class="d-flex align-center">
			<v-container class="mx-auto pa-0">
				<v-row no-gutters cols="12" class="p-0 m-0 fill-height my-auto">
					<v-col max-width="720" cols="12" sm="12" md="6" xs="12">
						<v-container class="fill-height p-0 m-0">
							<v-row class="fill-height p-0 m-0" no-gutters>
								<v-col class="pt-2" cols="12">
									<router-link :to="{ path: '/' }" title="TicketShop" tag="a"><v-img max-height="64"
											max-width="85" src="/images/Logo-black.svg"></v-img>
									</router-link>
								</v-col>
								<v-col cols="12" max-height="456">
									<v-card no-gutters flat class="d-flex mx-auto align-content-space-around flex-column"
										max-width="360">
										<v-card-title class="ml-0 pl-0 text-h4 font-weight-bold" tag="h4">
											Iniciar sesión
										</v-card-title>
										<v-card-subtitle class="ml-0 pl-0" style="
												font-size: 16px;
												font-weight: 700;
											" tag="h6">Bienvenido, por favor ingrese sus
											datos
										</v-card-subtitle>

										<!-- //Formulario  -->
										<v-form @submit.prevent="doLogin" autocomplete="on"
											class="mb-0 align-content-space-between"><v-text-field class="p-0 m-0" height="56px"
												label="Ingrese su correo" placeholder="Ingrese su correo" outlined required v-model="user.email
													"></v-text-field>
											<v-text-field class="m-0" height="56px" label="Contraseña" placeholder="Contraseña"
												outlined type="password" required v-model="user.password
													"></v-text-field>
											<v-row class="m-0 p-0 d-flex justify-content-between align-items-center flex-nowrap"
												max-width="360">
												<v-checkbox class="text-subtitle-2" v-model="checkbox"
													:label="`Recuerdame`"></v-checkbox>
												<a @click.prevent="goPasswordReset
													" href="#" class="primary--text text-subtitle-2">Olvide mi contraseña</a>
											</v-row>

											<v-btn class="text-button" color="primary" height="44px" block rounded
												type="submit">Iniciar Sesión
											</v-btn>
											<router-link :to="{ path: '/' }" title="TicketShop" tag="a">
											<v-btn outlined class="text-button mt-4" color="primary" height="44px" block rounded
												type="submit">Volver
											</v-btn>
										</router-link>
										</v-form>
										<v-row class="m-0 p-0 d-flex align-items-center flex-nowrap" block max-width="360">
											<v-card-text class="pl-0 ml-0 text-subtitle-2">¿No tienes cuenta de
												usuario?</v-card-text>
											<router-link :to="{ path: '/registro' }">
												<a href="#" class="primary--text text-subtitle-2">Registrarme</a>
											</router-link>
										</v-row>
									</v-card>
								</v-col>
								<v-spacer></v-spacer>
								<v-col class="py-4 py-md-0 ">
									<v-text tag="h6" width="100%" class="d-flex align-self-sm-end ml-5  text-body-2">
										© TicketShop
										{{ new Date().getFullYear() }} Colombia.
									</v-text>
								</v-col>
							</v-row>
						</v-container>
					</v-col>
					<v-col class="d-none d-sm-none d-md-flex" max-width="720" cols="6">
						<v-img cols="6" md="6" lg="6" xl="6" cover src="/images/login/LOGIN.webp">
						</v-img>
					</v-col>
				</v-row>
			</v-container>
		</v-main>
	</v-app>
</template>
<script>
export default {
	created() { },
	data() {
		return {
			user: {
				email: null,
				password: null,
			},
		};
	},
	methods: {
		doLogin() {
			this.$store.dispatch("doLogin", this.user);
		},
		showFormRegister() {
			this.$store.state.modalLogin = false;
			this.$store.state.modalRegister = true;
		},
		goPasswordReset() {
			this.$store.state.modalLogin = false;
			this.$router.push("/passwordReset");
		},
		hideModalLogin() {
			this.$store.commit("showModalLogin", false);
		},
	},
	computed: {
		modalLogin() {
			return this.$store.getters["modalLogin"];
		},
	},
};
</script>
